import cn from "classnames"
import React, { useEffect, useRef, useState } from "react"
import Swiper from "swiper"

import { LazyImage } from "~/components/LazyImage/LazyImage"

import styles from "./index.module.css"

export const SliderWrapper = ({
  className,
  containerClassName,
  slides,
  params,
  children,
  onInit,
  isMany,
}) => {
  const sliderEl = useRef(null)
  const wrapperEl = useRef(null)
  const [slider, setSlider] = useState()

  const destroySlider = () => {
    slider.destroy()
  }
  const initSlider = () => {
    if (!isMany) {
      return
    }

    const paginationEl = wrapperEl.current.querySelector(".swiper-pagination")
    const navigationNextEl = wrapperEl.current.querySelector(".swiper-button-next")
    const navigationPrevEl = wrapperEl.current.querySelector(".swiper-button-prev")
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(sliderEl.current, {
      simulateTouch: false,
      loop: true,
      a11y: false,
      pagination: {
        el: paginationEl,
        bulletClass: styles.Bullet,
        bulletActiveClass: "_active",
        clickable: true,
      },
      navigation: {
        nextEl: navigationNextEl,
        prevEl: navigationPrevEl,
      },
      lazy: { loadOnTransitionStart: true },
      ...params,
    })

    const lazyImageReady = (slide) => {
      const imageWrappers = [...slide.querySelectorAll("[data-js=slider__image-wrapper]")]
      imageWrappers.forEach((item) => (item.dataset.state = "image-loaded"))
    }

    swiper.on("lazyImageReady", lazyImageReady)

    onInit && onInit(swiper)
    setSlider(swiper)
  }

  // TODO: Исправить зависимости в хуке
  useEffect(() => {
    if (slider) {
      destroySlider()
      initSlider()
    } else {
      initSlider()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slides])

  return (
    <div ref={wrapperEl} className={className}>
      <div ref={sliderEl} className={cn(styles.Container, containerClassName)}>
        <div className={styles.Inner}>{slides()}</div>
      </div>

      {children}
    </div>
  )
}

SliderWrapper.Image = ({ image, placeholder, className, isMany, ...props }) => {
  if (!isMany) {
    return <LazyImage className={className} placeholderSrc={placeholder} src={image} />
  }

  return (
    <div className={cn(styles.ImageWrapper, className)} data-js="slider__image-wrapper" {...props}>
      {placeholder && (
        <div className={styles.Placeholder}>
          <img alt="" src={placeholder} />
        </div>
      )}
      <img alt="" className={styles.Image} data-src={image} />
    </div>
  )
}

SliderWrapper.Slide = ({ children, className, as, isMany, ...props }) => {
  const Component = as || "div"
  return (
    <Component
      className={cn(className, styles.Slide, {
        ["swiper-slide-active"]: !isMany,
      })}
      {...props}
    >
      {children}
    </Component>
  )
}

SliderWrapper.Pagination = ({ className }) => (
  <div className={cn(className, styles.Pagination)} data-js="slider__pagination" />
)

SliderWrapper.ArrowPrev = ({ className, isDefaultStyles }) => (
  <div
    className={cn(className, styles.ArrowPrevDefault, { [styles.ArrowPrev]: !isDefaultStyles })}
    data-js="slider__arrow-prev"
  />
)

SliderWrapper.ArrowNext = ({ className, isDefaultStyles }) => (
  <div
    className={cn(className, styles.ArrowNextDefault, { [styles.ArrowNext]: !isDefaultStyles })}
    data-js="slider__arrow-next"
  />
)
